import { css, DefaultTheme, css as baseCss } from 'styled-components';
import { em } from 'polished';

type Size = {
  min: number;
  max: number;
};

type SizeMap = {
  [type: string]: Size;
};

type ThemedCss<T extends object> = <Props extends object = object>(
  // eslint-disable-next-line prettier/prettier
  ...args: Parameters<typeof baseCss<Props & { theme?: T }>>
) => ReturnType<typeof baseCss<Props & { theme?: T }>>;

export const sizes: SizeMap = {
  thinMobile: { min: 200, max: 319 },
  mobile: { min: 320, max: 480 },
  tablet: { min: 481, max: 768 },
  laptop: { min: 768, max: 1024 }
};

/**
 * Sample usage:
 * const myDiv = styled.div`
 *  display: flex;
 *  ${media.mobile`
 *    flex-direction: column;
 *  `}
 * `;
 */
const media: { [size: string]: ThemedCss<DefaultTheme> } = Object.entries(sizes).reduce(
  (acc: any, [key, size]) => {
    acc[key] = (...args: any) => css`
      @media (max-width: ${em(size.max)}) {
        ${css(args.length > 0 ? args : [])};
      }
    `;
    return acc;
  },
  []
);

export default media;
